import { ContentCollapsible } from '@app/components/blocks/contentCollapsible/ContentCollapsible'
import { Text } from '@app/components/core/typography/Text'

const COLLAPSED_LINE_COUNT = 5

export type LandingContentDescriptionProps = {
  description: string
}

export const LandingContentDescription = ({
  description,
}: LandingContentDescriptionProps) => {
  return (
    <ContentCollapsible truncateAfter={COLLAPSED_LINE_COUNT}>
      <Text.Medium>{description}</Text.Medium>
    </ContentCollapsible>
  )
}
